import { createTheme } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

import { breakpoints } from './breakpoints';
import { capitalDesignTokens } from './capital_design_tokens';
import { components } from './components';
import { darkPalette } from './darkPalette';
import { lightPalette } from './lightPalette';
import { shape } from './shape';
import { getTypography } from './typography';
export type {} from './breakpoints';
export { capitalDesignTokens } from './capital_design_tokens';
export type {} from './capital_design_tokens';
export type {} from './components';
export {} from './lightPalette';
export type {} from './typography';

export function convertTokensToMuiTheme(tokens: typeof capitalDesignTokens, mode: 'light' | 'dark') {
  return createTheme({
    palette: mode === 'light' ? lightPalette : darkPalette,
    typography: getTypography,
    components,
    breakpoints,
    shape,
    ...tokens
  });
}

export const capitalMuiTheme = convertTokensToMuiTheme(capitalDesignTokens, 'light');
export const capitalMuiDarkTheme = convertTokensToMuiTheme(capitalDesignTokens, 'dark');
